import { render, staticRenderFns } from "./CreateInstitution.vue?vue&type=template&id=935bad76&"
import script from "./CreateInstitution.vue?vue&type=script&lang=js&"
export * from "./CreateInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports